import { getAxios } from '../../lib/projectAxios'
const axios = getAxios()

import { CLOSE_LOADING_WINDOW, SHOW_LOADING_WINDOW } from './actionTypes'

export const processAddressValidation = async (address, dispatch) => {
  try {
    dispatch({
      type: SHOW_LOADING_WINDOW,
      payload: {
        messages: [],
      },
    })

    const { data } = await axios.post('/webprojects/flow/addressValidate', { address })

    dispatch({ type: CLOSE_LOADING_WINDOW })

    return {
      data,
      error: false,
    }
  } catch (err) {
    console.error(err)

    return {
      error: true,
    }
  }
}
